import React from 'react';

import { useEffect } from 'react';
import { useGroupUserInvitationsState, useGroupUserInvitationsActions } from './GroupUserInvitationsContext';

import GroupUserInvitationsLoader from './GroupUserInvitationsLoader';
import NewGroupUserInvitationForm from './NewGroupUserInvitationForm';
import GroupUserInvitationsTable from './GroupUserInvitationsTable';
import Stack from '../../Shared/UI/Stack/components/Stack';

import styles from './GroupUserInvitations.module.scss';

const GroupUserInvitationsContent = () => {
  const state = useGroupUserInvitationsState();
  const groupPath = state?.groupId ? `/groups/${state.groupId}` : null;

  return (
    <div className={styles.pageLayout}>
      <Stack gap="lg">
        {groupPath && (
          <a href={groupPath} style={{ fontSize: '20px', color: '#007753', textDecoration: 'none' }}>
            &lt; Back to Group
          </a>
        )}
        <h2 className={styles.tableTitle}>
          Generate And Send Open User Invitations
        </h2>
        <NewGroupUserInvitationForm />
        <h2 className={styles.tableTitle}>
          Open User Invitations
        </h2>
        <GroupUserInvitationsTable />
      </Stack>
    </div>
  );
};

const GroupUserInvitations = ({ groupId }) => {
  const { initializeState } = useGroupUserInvitationsActions();

  useEffect(() => {
    initializeState(groupId);
  }, []);

  return (
    <>
      <GroupUserInvitationsLoader />
      <GroupUserInvitationsContent />
    </>
  );
}

export default GroupUserInvitations;
